import request from '../utils/request';

// 我的消息列表
export function getMyMessageLists() {
  return request({
    url: '/frontExhibitor/message/getMsgList',
    method: 'get',
  });
}

// 获取聊天记录;
export function getMessage(data) {
  return request({
    url: '/frontExhibitor/message/getMsgRecord',
    method: 'get',
    params: data,
  });
}

// 获取展商信息
export function getzsMessage(data) {
  return request({
    url: '/frontExhibitor/exhibitor/view',
    method: 'get',
    params: data,
  });
}

// 发送信息
export function sendMessage(data) {
  return request({
    url: '/frontExhibitor/message/sendMsg',
    method: 'post',
    data: data,
  });
}


// 获取收到的名片列表
export function getCardList(data) {
  return request({
    url: '/frontExhibitor/zsCard/list',
    method: 'get',
    params: data,
  });
}
